import { ListItemText } from '@mui/material';
import { memo } from 'react';
import Typography from '../../../Typography';
import { S1 } from '../../../../theme';

export interface INavigationItemProps{
  text: string;
}

const buildSX = () => ({
  userSelect: 'none',
  margin: '0px 0px 0px 32px',
  color: S1,
});

const NavigationSubHeader = (props: INavigationItemProps) => {
  const { text } = props;
  return (
    <ListItemText sx={buildSX()}>
      <Typography variant="caption">{text}</Typography>
    </ListItemText>
  );
};

export default memo(NavigationSubHeader);
